"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPerformanceReportPeriod = void 0;
const createPerformanceReportPeriod = (object = {
    from: '',
    to: '',
}) => object;
exports.createPerformanceReportPeriod = createPerformanceReportPeriod;
